export default {"src":"/_next/static/media/hero.4cbdf3d5.svg","height":992,"width":992,"blurWidth":0,"blurHeight":0};